// @flow
/**
 * @module Actions/Categoria
 * @desc Actions for Categoria
 */
import { ActionTypes } from '../utils/constants';

/**
 * Fetch test drive info request
 * @returns {Object}
 */
export function fetchTestDriveInfoRequest() {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_INFO_REQUEST,
  };
}

/**
 * Fetch test drive info success
 * @param {Object} info
 * @returns {Object}
 */
export function fetchTestDriveInfoSuccess(info) {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_INFO_SUCCESS,
    payload: { info },
  };
}

/**
 * Fetch test drive info failure
 * @returns {Object}
 */
export function fetchTestDriveInfoFailure() {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_INFO_FAILURE,
  };
}

/**
 * Fetch test drive rvsp
 * @returns {Object}
 */
export function fetchTestDriveRsvpRequest(id) {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_RSVP_REQUEST,
    payload: { id }
  };
}

/**
 * Fetch test drive rvsp success
 * @param {Object} info
 * @returns {Object}
 */
export function fetchTestDriveRsvpSuccess(info) {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_RSVP_SUCCESS,
    payload: { info },
  };
}

/**
 * Fetch test drive rvsp failure
 * @returns {Object}
 */
export function fetchTestDriveRsvpFailure() {
  return {
    type: ActionTypes.FETCH_TEST_DRIVE_RSVP_FAILURE,
  };
}

/**
 * Request test drive request
 * @param {Object} testDrive
 * @returns {Object}
 */
export function requestTestDriveRequest(testDrive) {
  return {
    type: ActionTypes.REQUEST_TEST_DRIVE_REQUEST,
    payload: { testDrive },
  };
}

/**
 * Request test drive success
 * @param {Object} data
 * @returns {Object}
 */
export function requestTestDriveSuccess(data) {
  return {
    type: ActionTypes.REQUEST_TEST_DRIVE_SUCCESS,
    payload: { data },
  };
}

/**
 * Request test drive failure
 * @returns {Object}
 */
export function requestTestDriveFailure() {
  return {
    type: ActionTypes.REQUEST_TEST_DRIVE_FAILURE,
  };
}

/**
 * Request test drive reset
 * @returns {Object}
 */
export function requestTestDriveReset() {
  return {
    type: ActionTypes.REQUEST_TEST_DRIVE_RESET,
  };
}
